import HeroSection from '../components/HeroSection';

const HeroPage = ({ onOpenSignup }) => <HeroSection onOpenSignup={onOpenSignup} />;

export default HeroPage;